import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, LanguageKeyType, LocalService } from '../../../service/local.service';
import { HtmlViewerComponent } from '../../popups/html-viewer/html-viewer.component';

@Component({
  selector: 'app-language-single',
  templateUrl: './language-single.component.html',
  styleUrls: ['./language-single.component.scss']
})
export class LanguageSingleComponent implements OnInit {
  @Input() parentId = ''; @Input() languageKeyType: LanguageKeyType = LanguageKeyType.None;
  selectedLanguage = ''; languageContent = ''; @Input() isEnglishEditor: boolean = false;
  maxBodyHeight = 0; htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      content: 'language_single_in_' + this.htmlId
    };
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(150, true);
    this.cdr.detectChanges();
  }

  ngOnChanges(): void {
    this.selectedLanguage = '';
    this.languageContent = '';
  }

  onUpdate() {
    if (this.doCheck()) {
      this.languageManagementService.saveLanguageContainerSimple(this.parentId, LanguageKeyType.UserGuideContent, this.selectedLanguage, this.languageContent).subscribe(result => {
        this.localService.showInformationByStatus(result);
      });
    }
  }

  onLoadLanguage() {
    this.languageManagementService.getLanguageContainerSimple(this.parentId, LanguageKeyType.UserGuideContent, this.selectedLanguage).subscribe(result => {
      this.languageContent = result.key == this.selectedLanguage ? result.value : '';
      this.localService.onFocusNextInput(this.elementIds.content, FocusInputType.TextBox);
    });
  }

  doCheck() {
    let message = '';
    if (this.parentId == '') {
      message = '-';
    } else if (this.languageKeyType == LanguageKeyType.None) {
      message = '-';
    } else if (this.selectedLanguage == '') {
      message = '-';
    } else if (this.languageContent == '') {
      message = '-';
    }
    return message == '';
  }

  onShowhtmlPreview() {
    this.minimizeMaximizePopup(true);
    const modalRef = this.modalService.open(HtmlViewerComponent, { size: 'xl' });
    modalRef.componentInstance.isPopUp = true;
    modalRef.componentInstance.contentLanguageId = this.selectedLanguage;
    modalRef.componentInstance.content = this.languageContent;
    modalRef.result.then((result) => {
      this.minimizeMaximizePopup(false);
    }, (error) => {
      this.minimizeMaximizePopup(false);
    });
  }

  minimizeMaximizePopup(isMinimize) {
    let elements = document.getElementsByTagName('ngb-modal-window');
    if (elements && elements.length > 0) {
      let element = elements[0] as HTMLElement;
      element.setAttribute('style', "height:" + (isMinimize ? "2px;" : "100%"));
      let elementsBack = document.getElementsByTagName('ngb-modal-backdrop');
      let elementBack = elementsBack[0] as HTMLElement;
      elementBack.setAttribute('style', "height:" + (isMinimize ? "2px;" : "100%"));
    }
  }
}
